import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getRecentUpdates } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export interface RecentUpdateNotification {
  id: number;
  shipment_reference: string;
  reference: string;
  type: "quote_request" | "shipment" | "quotation" | "invoice";
  reference_title: string;
  notification: string;
  created: string;
  unread?: boolean;
  is_read?: boolean;
}

const useGetRecentUpdatesData = (
  options?: UseQueryOptions<RecentUpdateNotification[], unknown, RecentUpdateNotification[]>,
) =>
  useQuery<RecentUpdateNotification[]>({
    queryKey: [userQueryKeys.recentUpdates],
    queryFn: () => getRecentUpdates().then((res) => res.data),
    staleTime: 300000,
    ...options,
  });

export default useGetRecentUpdatesData;
